document.addEventListener("DOMContentLoaded", function () {

  const builder = document.querySelector(".cb-print-builder");
  const ds = (builder && builder.dataset) || {};

  const num = (v, fb) => {
    const n = parseFloat(v);
    return isNaN(n) ? fb : n;
  };

  /* =========================================================
     CONFIG  (values come from the section's Theme Editor
     settings via data attributes; fallbacks below)
  ========================================================= */

  const CONFIG = {
    fallbackPhone: "91XXXXXXXXXX",
    deliveryFee:   num(ds.delivery, 40),
    maxFileMB:     num(ds.maxmb, 100),
    maxFiles:      num(ds.maxfiles, 15),
    accepted: [".pdf", ".doc", ".docx", ".ppt", ".pptx", ".jpg", ".jpeg", ".png"],
    price: {
      A4: { "Black & White": num(ds.a4bw, 3),  "Color": num(ds.a4color, 10) },
      A3: { "Black & White": num(ds.a3bw, 20), "Color": num(ds.a3color, 25) }
    }
  };

  const phone = (ds.whatsapp && ds.whatsapp.trim()) || CONFIG.fallbackPhone;

  /* =========================================================
     ELEMENTS
  ========================================================= */

  const fileInput    = document.getElementById("fileElem");
  const fileList     = document.getElementById("file-list");
  const fileError    = document.getElementById("file-error");

  const paperInput   = document.getElementById("paper");
  const colorInput   = document.getElementById("color");
  const modeInput    = document.getElementById("mode");
  const pagesInput   = document.getElementById("pages");
  const copiesInput  = document.getElementById("copies");

  const docPrice     = document.getElementById("doc-price");
  const deliveryLine = document.getElementById("delivery-price");
  const totalPrice   = document.getElementById("total-price");

  const sumPaper     = document.getElementById("summary-paper");
  const sumColor     = document.getElementById("summary-color");
  const sumPages     = document.getElementById("summary-pages");
  const sumCopies    = document.getElementById("summary-copies");

  const whatsappBtn  = document.getElementById("whatsapp-order");
  const pagesHint    = document.getElementById("pages-hint");

  let selectedFiles = [];

  /* =========================================================
     OPTION CARD SELECTION
  ========================================================= */

  function activate(groupId, input) {
    const group = document.getElementById(groupId);
    if (!group) return;

    group.querySelectorAll(".option-card").forEach(card => {
      card.addEventListener("click", function () {
        group.querySelectorAll(".option-card")
             .forEach(c => c.classList.remove("active"));
        this.classList.add("active");
        input.value = this.dataset.value;
        calculate();
      });
    });
  }

  activate("paper-group", paperInput);
  activate("color-group", colorInput);
  activate("mode-group",  modeInput);

  /* =========================================================
     PRICE LABELS on B&W / Color buttons
  ========================================================= */

  function updatePriceLabels() {
    const bw    = document.querySelector('#color-group .option-card[data-value="Black & White"]');
    const color = document.querySelector('#color-group .option-card[data-value="Color"]');
    if (!bw || !color) return;

    const table = CONFIG.price[paperInput.value] || CONFIG.price.A4;

    bw.innerHTML    = `<strong>B&amp;W</strong><small>&#8377;${table["Black & White"]} / page</small>`;
    color.innerHTML = `<strong>Color</strong><small>&#8377;${table["Color"]} / page</small>`;
  }

  /* =========================================================
     CALCULATE
  ========================================================= */

  function calculate() {
    const table   = CONFIG.price[paperInput.value] || CONFIG.price.A4;
    const perPage = table[colorInput.value] || 0;

    const pages   = Math.max(1, parseInt(pagesInput.value)  || 1);
    const copies  = Math.max(1, parseInt(copiesInput.value) || 1);

    const printing = perPage * pages * copies;
    const delivery = modeInput.value === "Delivery" ? CONFIG.deliveryFee : 0;
    const total    = printing + delivery;

    sumPaper.textContent  = paperInput.value;
    sumColor.textContent  = colorInput.value;
    sumPages.textContent  = pages;
    sumCopies.textContent = copies;

    docPrice.textContent     = "\u20B9" + printing;
    deliveryLine.textContent = delivery ? "\u20B9" + delivery : "FREE";
    totalPrice.textContent   = "\u20B9" + total;

    updatePriceLabels();
  }

  pagesInput.addEventListener("input", calculate);
  copiesInput.addEventListener("input", calculate);

  /* =========================================================
     FILE HANDLING  (validation + preview + remove)
  ========================================================= */

  function isAccepted(name) {
    const lower = name.toLowerCase();
    return CONFIG.accepted.some(ext => lower.endsWith(ext));
  }

  /* ---------- Auto page-count (PDF via pdf.js, images = 1 page) ---------- */

  let pdfLibPromise = null;

  function loadPdfLib() {
    if (window.pdfjsLib) return Promise.resolve(window.pdfjsLib);
    if (pdfLibPromise) return pdfLibPromise;

    pdfLibPromise = new Promise((resolve, reject) => {
      const s = document.createElement("script");
      s.src = "https://cdnjs.cloudflare.com/ajax/libs/pdf.js/3.11.174/pdf.min.js";
      s.onload = () => {
        if (window.pdfjsLib) {
          window.pdfjsLib.GlobalWorkerOptions.workerSrc =
            "https://cdnjs.cloudflare.com/ajax/libs/pdf.js/3.11.174/pdf.worker.min.js";
          resolve(window.pdfjsLib);
        } else {
          reject(new Error("pdf.js unavailable"));
        }
      };
      s.onerror = () => reject(new Error("pdf.js failed to load"));
      document.head.appendChild(s);
    });

    return pdfLibPromise;
  }

  async function detectPages(file) {
    if (file.__cbCountable !== undefined) return; // cached
    const lower = file.name.toLowerCase();

    if (lower.endsWith(".pdf")) {
      try {
        const lib = await loadPdfLib();
        const buf = await file.arrayBuffer();
        const doc = await lib.getDocument({ data: buf }).promise;
        file.__cbPages = doc.numPages;
        file.__cbCountable = true;
      } catch (err) {
        file.__cbPages = 0;
        file.__cbCountable = false;
      }
    } else if (/\.(jpg|jpeg|png)$/.test(lower)) {
      file.__cbPages = 1;
      file.__cbCountable = true;
    } else {
      file.__cbPages = 0;
      file.__cbCountable = false; // doc/docx/ppt/pptx -> manual
    }
  }

  async function recomputePages() {
    if (!pagesHint) return;

    if (!selectedFiles.length) {
      pagesHint.textContent = "";
      return;
    }

    pagesHint.textContent = "Counting pages...";
    await Promise.all(selectedFiles.map(detectPages));

    let total = 0;
    let manual = 0;
    selectedFiles.forEach(f => {
      if (f.__cbCountable) total += (f.__cbPages || 0);
      else manual++;
    });

    if (total > 0) {
      pagesInput.value = total;
      calculate();
    }

    let msg = total > 0
      ? `Auto-detected ${total} page${total > 1 ? "s" : ""} from your files.`
      : "";
    if (manual > 0) {
      msg += (msg ? " " : "") +
        `${manual} Word/PPT file${manual > 1 ? "s" : ""} can't be counted automatically, please set pages manually.`;
    }
    pagesHint.textContent = msg;
  }

  function renderFiles() {
    fileList.innerHTML = "";

    selectedFiles.forEach((file, index) => {
      const item = document.createElement("div");
      item.className = "file-card";
      item.innerHTML = `
        <div class="file-meta">
          <span class="file-name">&#128196; ${file.name}</span>
          <span class="file-size">${(file.size / 1024 / 1024).toFixed(2)} MB</span>
        </div>
        <button type="button" class="file-remove" data-index="${index}" aria-label="Remove file">&times;</button>
      `;
      fileList.appendChild(item);
    });

    fileList.querySelectorAll(".file-remove").forEach(btn => {
      btn.addEventListener("click", function () {
        selectedFiles.splice(parseInt(this.dataset.index), 1);
        renderFiles();
        recomputePages();
      });
    });
  }

  function handleFiles(files) {
    const before = selectedFiles.length;
    const rejected = [];

    Array.from(files).forEach(file => {
      if (selectedFiles.length >= CONFIG.maxFiles) {
        rejected.push(`${file.name} (max ${CONFIG.maxFiles} files)`);
        return;
      }
      if (!isAccepted(file.name)) {
        rejected.push(`${file.name} (unsupported format)`);
        return;
      }
      if (file.size / 1024 / 1024 > CONFIG.maxFileMB) {
        rejected.push(`${file.name} (over ${CONFIG.maxFileMB} MB)`);
        return;
      }
      selectedFiles.push(file);
    });

    fileError.textContent = rejected.length
      ? "Skipped: " + rejected.join(", ")
      : "";

    renderFiles();
    recomputePages();

    // If files were added from the hero card, move the user to the calculator.
    if (selectedFiles.length > before) {
      const target = document.getElementById("upload");
      if (target) target.scrollIntoView({ behavior: "smooth", block: "start" });
    }
  }

  if (fileInput) {
    fileInput.addEventListener("change", function () {
      handleFiles(this.files);
      this.value = "";
    });
  }

  document.querySelectorAll(".cb-dropzone").forEach(zone => {
    ["dragenter", "dragover"].forEach(evt =>
      zone.addEventListener(evt, e => {
        e.preventDefault();
        zone.classList.add("dragging");
      })
    );

    ["dragleave", "drop"].forEach(evt =>
      zone.addEventListener(evt, e => {
        e.preventDefault();
        zone.classList.remove("dragging");
      })
    );

    zone.addEventListener("drop", e => {
      if (e.dataTransfer && e.dataTransfer.files.length) {
        handleFiles(e.dataTransfer.files);
      }
    });
  });

  /* =========================================================
     WHATSAPP
  ========================================================= */

  whatsappBtn.addEventListener("click", function (e) {
    e.preventDefault();

    const fileNames = selectedFiles.length
      ? selectedFiles.map(f => "- " + f.name).join("\n")
      : "(will attach in this chat)";

    const message =
`Hello CharmBox,

I would like to print my documents.

Paper Size: ${paperInput.value}
Print Type: ${colorInput.value}
Pages per copy: ${pagesInput.value}
Copies: ${copiesInput.value}
Delivery: ${modeInput.value}

Files:
${fileNames}

Estimated Printing Cost: ${docPrice.textContent}
Estimated Total: ${totalPrice.textContent}

Please share the final quotation. I will attach my files in this chat.

Thank you.`;

    window.open(
      `https://wa.me/${phone}?text=${encodeURIComponent(message)}`,
      "_blank"
    );
  });

  calculate();
});

/* =========================================================
   FAQ ACCORDION
========================================================= */

document.querySelectorAll(".cb-faq-question").forEach(question => {
  question.addEventListener("click", () => {
    const item     = question.parentElement;
    const isActive = item.classList.contains("active");

    document.querySelectorAll(".cb-faq-item").forEach(faq => {
      faq.classList.remove("active");
      faq.querySelector(".cb-faq-question").setAttribute("aria-expanded", "false");
      faq.querySelector(".cb-faq-icon").textContent = "+";
    });

    if (!isActive) {
      item.classList.add("active");
      question.setAttribute("aria-expanded", "true");
      item.querySelector(".cb-faq-icon").textContent = "\u2212";
    }
  });
});
